/* unplugin-vue-components disabled */import script from "./CompetitionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionDialog.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionDialog.vue?vue&type=style&index=0&id=7039c1bc&lang=css"

const __exports__ = script;

export default __exports__